import React from 'react';
import PropTypes from 'prop-types';

import './graph.scss';
import Strings from '../../Strings';
import GenericCategoryGraph, { chartTypeEnum } from './GenericCategoryGraph';

export default function MonitoringCodesGraph(props) {
  const { graphData, graphType, colorPalette, rpm } = props;
  const dataSeries = [
    {
      name: 'Enrollments with Monitoring Code',
      color: colorPalette?.interpolate(0.73),
      colors: [colorPalette?.interpolate(0.83), colorPalette?.interpolate(0.73)],
      selector: item => item.hasCode,
    },
    {
      name: "Enrollments without Monitoring Code",
      color: colorPalette?.interpolate(0.24),
      colors: [colorPalette?.interpolate(0.14), colorPalette?.interpolate(0.24)],
      selector: item => item.doesntHaveCode,
    },
  ];

  const dataSeriesRpm = [
    {
      name: 'RPM',
      color: colorPalette?.interpolate(0.73),
      selector: item => item.count,
    },
  ];

  return (
    <GenericCategoryGraph
      graphData={graphData}
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={graphType === chartTypeEnum.horizontalStackedBar && graphData?.[0]?.program === 'RTM' ? 200 : 40}
      yAxisUnit=""
      tooltipTitle={Strings.enrollment}
      dataSeries={rpm ? dataSeriesRpm : dataSeries}
      categorySelector={item => rpm ? item.category : item.program}
      layerNames={['RTM', 'Subprograms']}
      hasReferenceAreas
      graphType={graphType}
      colorPalette={colorPalette}
    />
  );
}

MonitoringCodesGraph.propTypes = { graphData: PropTypes.array };
